import { Container, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import React, { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { Card, CardContent, CardMedia } from '@mui/material';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { MyMButton } from '../../ui-elements/MyMButton';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version2.0 ServiceLv2_3画面新規追加
 * ServiceLv2_3 Page Component
 */
const ServiceLv2SubLv3 = () => {

  const screenId = 'MyM322';
  const { controlSettings, screenSettings, commonFiles } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [previewFileId, setPreviewFileId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [mdapMetadataList, setMDAPMetadataList] = useState(true);
  const handleModalClose = () => setPreviewFileId(null);
  const isPc = useMediaQuery(mediaQuery.pc);

  const OutlinedMediaLinkMultipleDescriptionCard = (props) => {
    const { index, navigateTo, navigateState, mediaImageFileName, caption, description, mdapMasterPlanLabel, mdapPreviewFileId, mdapMasterPlanThumbnailFileName, mdapLabel, mdapLink } = props;
    const [hovered, setHovered] = useState(false);
    return (
      <Grid item xs={12} md={6} key={index}>
        <Card
          variant="outlined"
          sx={{
            height: "100%",
            borderRadius: "10px",
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >

          <Box position="relative" display="inline-block" width="100%" className='media-box'>
            <NavigateLink to={navigateTo} navigateState={navigateState} underline="none" className='py-0 h-100 w-100'>
              <CardMedia
                width="100%"
                display="block"
                sx={{ height: 170, opacity: "0.5", zIndex: "30", visibility: hovered ? 'visible' : 'hidden' }}
                image={`${process.env.PUBLIC_URL}/${screenId}/${mediaImageFileName}`}
              />
              <Box
                position="absolute"
                top="0"
                left="0"
                color="white"
                padding="10px"
                height="100%"
                width="100%"
                sx={{ backgroundColor: "rgb(13 13 13 / 55%)", zIndex: "20" }}
              >
                <MyMVariantLabel
                  variant="h4"
                  position="absolute"
                  top="50%"
                  left="50%"
                  textAlign="center"
                  className='caption'
                  sx={{
                    transform: 'translate(-50%, -50%)',
                    WebkitTransform: 'translate(-50%, -50%)',
                    msTransform: 'translate(-50%, -50%)',
                    width: "100%",
                  }}
                >
                  {caption}
                </MyMVariantLabel>
              </Box>
            </NavigateLink>
          </Box>
          <CardContent sx={{ paddingTop: "10px", paddingBottom: '6px !important', width: "100%", minHeight: 270 }}>
            <Box sx={{ minHeight: 260 }}>
              <MyMLabel sx={{ textAlign: "left", }} whiteSpace="normal !important" className='description'>
                {description}
              </MyMLabel>
            </Box>

            <Box className='ps-2 pt-1 pb-2' sx={{ bgcolor: '#f5f5f5' }}>
              <MyMLabel className='py-1'>{mdapMasterPlanLabel}</MyMLabel>
              <Box
                className='d-flex justify-content-center align-items-center'
                sx={{ cursor: 'pointer' }}
                onClick={(e) => onClickPreview(e, mdapPreviewFileId)}>
                <MyMImage
                  screenId={screenId}
                  filePath={mdapMasterPlanThumbnailFileName}
                  width='40%'
                ></MyMImage>
              </Box>
            </Box>
            <Box className='d-flex align-items-center mt-2'>
              <MyMButton
                sx={{ backgroundColor: '#eeeeee !important', color: 'black !important', ml: 'auto' }}
                onClick={() => window.open(mdapLink, '_blank')}
              >
                {mdapLabel}</MyMButton>

            </Box>

          </CardContent>
        </Card>
      </Grid>
    );
  }

  /**
   * プレビュー処理
   * @param {Event} e イベント引数
   * @param {string} fileId ファイルID
   */
  const onClickPreview = (e, fileId) => {
    setPreviewFileId(fileId);
  }

  useEffect(() => {
    const callbackRequest = (result) => {
      setMDAPMetadataList(result.MDAPMetadataList)
      setIsLoading(false);
    }
    apiRequest.requestJson('api/service/lv2-3', 'GET', callbackRequest)
  }, []);

  if (isLoading)
    return <MyMProgress />

  const splitSupportItems = controlSettings.LabelList.lblItems.split('\n');

  const postDeliveryCardPropList =
    [
      {
        caption: controlSettings.LabelList.lblLevel1,
        mediaImageFileName: controlSettings.ImageList.imgLevel1,
        description: format(controlSettings.LabelList.lblLevel1Description, <span style={{ fontWeight: 'bold' }}>{controlSettings.LabelList.lblLevel1DescriptionHighlight}</span>),
        navigateTo: `MyM323/${mdapMetadataList[0].Id}`,
        navigateState: { state: { breadcrumb: controlSettings.LabelList.lblLevel1 } }
      },
      {
        caption: controlSettings.LabelList.lblLevel2,
        mediaImageFileName: controlSettings.ImageList.imgLevel2,
        description: format(controlSettings.LabelList.lblLevel2Description, <span style={{ fontWeight: 'bold' }}>{controlSettings.LabelList.lblLevel2DescriptionHighlight}</span>),
        navigateTo: `MyM323/${mdapMetadataList[1].Id}`,
        navigateState: { state: { breadcrumb: controlSettings.LabelList.lblLevel2 } }
      },
    ];

  const mdapControlPropList =
    [
      {
        masterPlanLabel: controlSettings.LabelList.lblMasterPlanLevel1,
        masterPlanThumbnailFileName: controlSettings.ImageList.imgMasterPlanLevel1,
        previewFileId: commonFiles.PostDeliveryMasterPlanLv1FileId,
        mdapLabel: controlSettings.LabelList.lblMDAPLevel1,
        mdapLink: screenSettings.MDAP_L1Url,
      },
      {
        masterPlanLabel: controlSettings.LabelList.lblMasterPlanLevel2,
        masterPlanThumbnailFileName: controlSettings.ImageList.imgMasterPlanLevel2,
        previewFileId: commonFiles.PostDeliveryMasterPlanLv2FileId,
        mdapLabel: controlSettings.LabelList.lblMDAPLevel2,
        mdapLink: screenSettings.MDAP_L2Url,
      },
    ];

  return (

    <Container fixed>
      <Stack spacing={3} className='d-flex justify-content-center align-items-center flex-column pb-2'>
        <MyMVariantLabel variant='h6'>{controlSettings.LabelList.lblHeader}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblDescription}</MyMLabel>
        <Stack
          className='d-flex justify-content-around px-4'
          direction='row'
          sx={{ border: '#BFBFBF 3px solid', borderRadius: '8px' }} >
          {
            isPc ?
              <>
                <List>
                  {splitSupportItems.slice(0, Math.trunc(splitSupportItems.length / 2)).map((x, i) =>
                    <ListItemText key={i}><MyMLabel>{x}</MyMLabel></ListItemText>
                  )}
                </List>
                <List className='ps-5'>
                  {splitSupportItems.slice(Math.trunc(splitSupportItems.length / 2), splitSupportItems.length).map((x, i) =>
                    <ListItemText key={i}><MyMLabel>{x}</MyMLabel></ListItemText>
                  )}
                </List>
              </>
              :
              <List>
                {splitSupportItems.map((x, i) =>
                  <ListItemText key={i}><MyMLabel>{x}</MyMLabel></ListItemText>
                )}
              </List>
          }
        </Stack>
        <Grid container columnSpacing={3}>
          {postDeliveryCardPropList.map((cardProp, i) =>
            <OutlinedMediaLinkMultipleDescriptionCard
              key={i}
              index={i}
              navigateTo={cardProp.navigateTo}
              navigateState={cardProp.navigateState}
              mediaImageFileName={cardProp.mediaImageFileName}
              caption={cardProp.caption}
              description={cardProp.description}
              mdapMasterPlanLabel={mdapControlPropList[i].masterPlanLabel}
              mdapPreviewFileId={mdapControlPropList[i].previewFileId}
              mdapMasterPlanThumbnailFileName={mdapControlPropList[i].masterPlanThumbnailFileName}
              mdapLabel={mdapControlPropList[i].mdapLabel}
              mdapLink={mdapControlPropList[i].mdapLink}
            ></OutlinedMediaLinkMultipleDescriptionCard>
          )}
        </Grid>
      </Stack>
      <MyMModal
        open={previewFileId !== null}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </Container>
  );
}
export default ServiceLv2SubLv3;
